const isMobileView = width => width === 'xs';

export default isMobileView;
